import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import {
  NewFocusGroupLayout,
  useFocusGroupFormStore,
  useFocusGroupRunStore,
} from '@/features/focus-group';

/**
 * `personaId` is the single-persona form the IQ persona detail has always used; `personaIds`
 * is the comma-separated form the Core Segments section sends when it starts a group against
 * every segment at once.
 */
const parsePersonaIds = (searchParams: URLSearchParams): string[] => {
  const many = searchParams.get('personaIds');
  const ids = many ? many.split(',') : [searchParams.get('personaId') ?? ''];
  return Array.from(new Set(ids.map((id) => id.trim()).filter(Boolean)));
};

export function NewFocusGroup() {
  const [searchParams] = useSearchParams();
  const personaIds = useMemo(() => parsePersonaIds(searchParams), [searchParams]);
  const analysisId = searchParams.get('analysisId');

  useEffect(() => {
    const store = useFocusGroupFormStore.getState();
    store.reset();
    useFocusGroupRunStore.getState().reset();
    if (personaIds.length > 0) {
      store.setSelectedPersonaIds(personaIds);
    }
    if (analysisId) {
      store.setAnalysisId(analysisId);
    }
  }, [personaIds, analysisId]);

  return <NewFocusGroupLayout />;
}
